import { useEffect } from 'react';

export function GoogleAnalytics() {
  const _ga4Id = process.env.NEXT_PUBLIC_GA4_ID;

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_GA4_ID) {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GA4_ID}`;
      script.async = true;
      document.body.appendChild(script);

      window.gtag('config', process.env.NEXT_PUBLIC_GA4_ID);
    }
  }, []);

  return null;
}
